import { useMatches } from 'react-router-dom';
import { RouteMatchShape } from '@/core/routes/routes.types';

function useBreadcrumbs() {
  const matches = useMatches() as RouteMatchShape[];
  const crumbs = matches
    .filter((match): match is { handle: { crumb: () => React.ReactNode } } =>
      Boolean(match.handle?.crumb),
    )
    .map((match) => match.handle.crumb());

  return crumbs;
}

export default useBreadcrumbs;
